/**
 * @generated SignedSource<<7afddf2c638dff08a76ce5daa8a3ad0c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpsertFeatureFlagInput = {
  description?: string | null;
  enabled?: boolean | null;
  name?: string | null;
  slug: string;
};
export type FeatureFlagsPageUpsertMutation$variables = {
  input: UpsertFeatureFlagInput;
};
export type FeatureFlagsPageUpsertMutation$data = {
  readonly UpsertFeatureFlag: {
    readonly error: string | null;
    readonly flag: {
      readonly description: string;
      readonly slug: string;
    } | null;
  };
};
export type FeatureFlagsPageUpsertMutation = {
  response: FeatureFlagsPageUpsertMutation$data;
  variables: FeatureFlagsPageUpsertMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpsertFeatureFlagPayload",
    "kind": "LinkedField",
    "name": "UpsertFeatureFlag",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "HardcodedFeatureFlag",
        "kind": "LinkedField",
        "name": "flag",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeatureFlagsPageUpsertMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeatureFlagsPageUpsertMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4af83ea8f5418ea81a39314a0e8167c7",
    "id": null,
    "metadata": {},
    "name": "FeatureFlagsPageUpsertMutation",
    "operationKind": "mutation",
    "text": "mutation FeatureFlagsPageUpsertMutation(\n  $input: UpsertFeatureFlagInput!\n) {\n  UpsertFeatureFlag(input: $input) {\n    flag {\n      slug\n      description\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "dcc716e1645163eeef2684922b254381";

export default node;
